const ADVANCED_BLOCKED_PLANS = [
  "free",
  "2025_pro",
  "2026_personal",
  "2026_prime",
  "2024_pages",
  "2024_core",
  "2024_funnels",
  "2024_pro",
  "2024_build",
  "2023_launch",
];

const mergeTagUpgradeGate = (badge, website) => {
  const upgradeElement =
    typeof document !== "undefined" ? document.getElementById("upgrade") : null;
  const planType =
    window.plan_type ||
    website?.plan_type ||
    upgradeElement?.getAttribute("data-plan-type");
  const premiumSite =
    website?.premium === true ||
    website?.premium === "true" ||
    upgradeElement?.getAttribute("data-website-premium") == "true";

  const blocked =
    !premiumSite ||
    (badge.advanced
      ? ADVANCED_BLOCKED_PLANS.includes(planType)
      : planType == "free");

  if (!blocked) return true;

  const [message, tier, source] = badge.advanced
    ? [
        "personalize using dynamic text replacements",
        String(planType || "").indexOf("2026") > -1 ? "pro" : "plus",
        "Triggered feature CTA – Merge Tags",
      ]
    : badge.type === "score"
    ? ["add funnel scores", "paid", "Triggered feature CTA – Funnel Score"]
    : [
        "add merge tags to your funnels",
        "paid",
        "Triggered feature CTA – Merge Tags",
      ];

  window.subscriptions?.upgrade_modal?.(
    undefined,
    false,
    message,
    tier,
    source
  );

  return false;
};

export default mergeTagUpgradeGate;
